<template>
  <v-container fill-height fluid>
    <v-row align="center" justify="center">
      <v-col align="center" cols="12" sm="8" md="6" lg="4">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th></th>
                <th colspan="2" class="text-center">
                  Martin
                  <v-icon v-on:click="loginAs('MTCHOY', 'staff')">mdi-login</v-icon>
                  <!-- <a href="http://localhost:1337/user/login/MTCHOY"><v-icon>mdi-login</v-icon></a> -->
                </th>
                <th>
                  William
                  <v-icon v-on:click="loginAs('WILLIAM', 'staff')">mdi-login</v-icon>
                </th>
              </tr>
              <tr>
                <th></th>
                <th>COMP4117</th>
                <th>COMP7270</th>
                <th>COMP4075</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  Suki
                  <v-icon v-on:click="loginAs('123456', 'student')">mdi-login</v-icon>
                </td>
                <td class="text-center">
                  <v-icon>mdi-check-circle</v-icon>
                </td>
                <td></td>
                <td></td>
              </tr>
              <tr>
                <td>
                  Natalie
                  <v-icon v-on:click="loginAs('223456', 'student')">mdi-login</v-icon>
                </td>
                <td class="text-center">
                  <v-icon>mdi-check-circle</v-icon>
                </td>
                <td class="text-center">
                  <v-icon>mdi-check-circle</v-icon>
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  Sherry
                  <v-icon v-on:click="loginAs('16219007', 'student')">mdi-login</v-icon>
                </td>
                <td class="text-center">
                  <!-- <v-icon>mdi-check-circle</v-icon> -->
                </td>
                <td class="text-center">
                  <!-- <v-icon>mdi-check-circle</v-icon> -->
                </td>
                <td class="text-center">
                  <v-icon>mdi-check-circle</v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import axios from "axios";

export default {
  name: "Login",

  methods: {
    async loginAs(sid) {
      if (process.env.NODE_ENV == "development") {
        window.location.assign("http://localhost:1337/user/login/" + sid);
      } else {
        window.location.assign(
          process.env.VUE_APP_API_BASE_URL + "/user/login/" + sid
        );
      }

      // var response = await fetch(
      //   process.env.VUE_APP_API_BASE_URL + "/user/login/" + sid,
      //   {
      //     method: "POST",
      //     credentials: "include",
      //     headers: {
      //       "Content-Type": "application/json"
      //       // 'Content-Type': 'application/x-www-form-urlencoded',
      //     },
      //     body: JSON.stringify({ role: role })
      //   }
      // );

      // if (response.ok) {
      //   var data = await response.json();
      //   // console.log("return : ", data);
      //   // alert("Welcome back, " +  data.username);

      //   window.location.assign(data);

      // } else {
      //   alert(response.status + ": " + response.statusText);
      // }
      // var response = await axios({
      //   url: "/user/login/",
      //   method: "post",
      //   baseURL: process.env.VUE_APP_API_BASE_URL,
      //   headers: {
      //     "Content-Type": "application/json"
      //   },
      //   data: {
      //     id: sid
      //   }
      // });

      // console.log(response);
    }
  }
};
</script>